import * as yup from 'yup'

export class DamagePhoto1Dto {
  damagePhoto1FileName?: string = undefined
  damagePhoto1File?: File | string = undefined
}

export const DamagePhoto1DtoSchema = yup.object({
  damagePhoto1FileName: yup.string().nullable(),
  damagePhoto1File: yup.mixed()
})
